import axios from 'axios';
import { mocking } from './mocking';

const CSRF_COOKIE_NAME = 'csrf-token';

const getCookieValue = (name: string): string | null => {
	const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
	return match ? decodeURIComponent(match[1]) : null;
};

const isUnsafeMethod = (method?: string): boolean => {
	if (!method) {
		return false;
	}

	const normalizedMethod = method.toUpperCase();
	return !['GET', 'HEAD', 'OPTIONS'].includes(normalizedMethod);
};

const instance = axios.create({
	// baseURL: 'http://localhost:9200', // do not prepend URL because it can be determined from browser
	responseType: 'json',
	transformRequest: JSON.stringify,
	headers: {
		'Content-Type': 'application/json'
	}
});

instance.interceptors.request.use((config) => {
	if (isUnsafeMethod(config.method)) {
		const csrfToken = getCookieValue(CSRF_COOKIE_NAME);
		if (csrfToken) {
			config.headers = config.headers ?? {};
			config.headers['x-csrf-token'] = csrfToken;
		}
	}

	return config;
});

export default instance;

mocking(instance, true);
